import React from 'react';

/**
 * Displays SQL query results in a table format
 * Props:
 *   - results: { columns: string[], values: any[][] }
 *   - title: string (optional table title)
 *   - empty Message: string (optional message when no results)
 */
const SQLResultsTable = ({ results, title, emptyMessage = 'No results' }) => {
  if (!results || results.columns.length === 0) {
    return (
      <div className="results-table-container">
        {title && <h3 className="results-table-title">{title}</h3>}
        <div className="results-empty">{emptyMessage}</div>
      </div>
    );
  }

  const { columns, values } = results;

  return (
    <div className="results-table-container">
      {title && <h3 className="results-table-title">{title}</h3>}
      <div className="results-table-wrapper">
        <table className="results-table">
          <thead>
            <tr>
              {columns.map((col, i) => (
                <th key={i}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {values.length === 0 ? (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: 'center' }}>
                  {emptyMessage}
                </td>
              </tr>
            ) : (
              values.map((row, rowIdx) => (
                <tr key={rowIdx}>
                  {row.map((cell, cellIdx) => (
                    <td key={cellIdx}>
                      {cell === null ? (
                        <span className="null-value">NULL</span>
                      ) : (
                        String(cell)
                      )}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="results-table-footer">
        {values.length} row{values.length !== 1 ? 's' : ''}
      </div>
    </div>
  );
};

export default SQLResultsTable;
